import React, { useRef } from 'react'
import type { OpenedSurvey } from './types'
import { cn } from './cn'
import { useOffsetContainerCtx } from './OffsetContainer'

export type InputProps = {
  questionId: string
  onSubmit: (values: {
    text: string
    questionId: string
    choiceId?: string
  }) => void
  loadingResponse: boolean
  choices: OpenedSurvey['question']['choices']
  onFocus: () => void
  onBlur: () => void
}

const Buttons = ({
  onSubmit,
  questionId,
  loadingResponse,
  onFocus,
  onBlur,
  choices,
}: InputProps) => {
  const formRef = useRef<HTMLFormElement>(null)

  const device = useOffsetContainerCtx(s => s.device)

  const handleSubmit = ({
    choiceId,
    text,
  }: {
    choiceId?: string
    text: string
  }) => {
    if (!text) {
      return
    }

    if (!loadingResponse) {
      onSubmit({
        choiceId,
        text,
        questionId,
      })
    }
  }

  return (
    <form
      ref={formRef}
      className="sp-mt-5 sp-leading-[0] sp-px-5 sp-mb-4"
      noValidate>
      <div className="sp-flex sp-gap-2.5 sp-flex-wrap">
        {choices.map(choice => (
          <button
            key={choice.id}
            type="button"
            disabled={loadingResponse}
            onFocus={onFocus}
            className={cn(
              'sp-bg-survey-user-bubble hover:sp-bg-survey-user-bubble-hover sp-rounded-[10px] sp-truncate sp-text-button',
              {
                'sp-px-2.5 sp-py-[5px]': device !== 'small',
                'min-w-[80px] sp-px-5 sp-py-2': device === 'small',
              }
            )}
            onBlur={onBlur}
            onMouseDown={e => {
              e.preventDefault()
            }}
            onClick={() => {
              handleSubmit({ text: choice.value, choiceId: choice.id })
            }}>
            {choice.value}
          </button>
        ))}
      </div>
    </form>
  )
}

export default Buttons
